"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Syn360DegreeViewer = void 0;
const _ = require("underscore");
const Utilities_1 = require("../Utilities");
const ProdSysBase_1 = require("./ProdSysBase");
class Syn360DegreeViewer extends ProdSysBase_1.ProdSysBase {
    static Open(instance) {
        return new ProdSysBase_1.ActionResult(false, instance.id.valueAsString);
    }
    static View(instance) {
        let instId = instance.id.valueAsString + "|" + instance.items["cgdocument.version"].valueToString();
        let url = Utilities_1.synUtil.getWSUrl("ContentInstanceDownloadable") + instId;
        url += "/32"; // Content.Types.Print
        Utilities_1.synUtil.getAJAXData({
            url,
            done(data) {
                if (data.downloadable) {
                    // Create Window
                    let windowData = Utilities_1.synUtil.popupWindow({
                        title: Utilities_1.synUtil.Strings.getValue("360degreeviewer"),
                        actions: ["Maximize", "Close"],
                        width: 1024,
                        height: 768,
                        resizable: true,
                        modal: true,
                        synDesktopAware: true
                    });
                    // Create viewer
                    let pannellumId = "pannellum_" + Utilities_1.synUtil.getGUID(true);
                    let viewerId = "viewer_" + Utilities_1.synUtil.getGUID(true);
                    let $div = $("<div></div>")
                        .css({
                        "height": "100%",
                    })
                        .attr({
                        "id": pannellumId,
                    })
                        .appendTo(windowData.contentDiv);
                    let $viewer = $("<div></div>")
                        .css({
                        "height": "100%",
                        "width": "100%",
                    })
                        .attr({
                        "id": viewerId,
                    })
                        .appendTo($div);
                    Utilities_1.synUtil.getAJAXData({
                        url: "WSProxy.axd?synws=Integration/GetTile/" + instId + "/config.json",
                        done(config) {
                            require.ensure(["../../../node_modules/pannellum/src/js/pannellum.js", "../../../node_modules/pannellum/src/css/pannellum.css"], function (require) {
                                let pannellum = require("../../../node_modules/pannellum/src/js/pannellum.js");
                                let libpannellum = require("../../../node_modules/pannellum/src/js/libpannellum.js");
                                let pannellumCss = require("../../../node_modules/pannellum/src/css/pannellum.css");
                                let vwr = window.pannellum.viewer(viewerId, {
                                    "type": "multires",
                                    "multiRes": {
                                        "basePath": "WSProxy.axd?synws=Integration/GetTile/" + instId,
                                        "path": config.multiRes.path,
                                        "fallbackPath": "WSProxy.axd?synws=Integration/GetTile/" + instId + "fallback/%s",
                                        "extension": config.multiRes.extension,
                                        "tileResolution": config.multiRes.tileResolution,
                                        "maxLevel": config.multiRes.maxLevel,
                                        "cubeResolution": config.multiRes.cubeResolution,
                                    },
                                    "autoLoad": true,
                                    "compass": false,
                                    "showFullscreenCtrl": typeof window.synDesktopApp !== "undefined" ? false : true,
                                });
                                $("#" + windowData.windowID).data("kendoWindow").bind("resize", _.debounce(function () {
                                    // let renderer = vwr.getRenderer();
                                    // renderer.resize();
                                }, 300));
                            });
                        }
                    });
                }
                else
                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("docnocontent"));
            }
        });
        return new ProdSysBase_1.ActionResult(true, instId);
    }
}
exports.Syn360DegreeViewer = Syn360DegreeViewer;
